/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class PitrRestoreWindow {
  /**
  * The earliest point in time that can be restored to within this range.
  */
  'earliest': Date;
  /**
  * The latest point in time that can be restored to within this range.
  */
  'latest': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "earliest",
      "baseName": "earliest",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "latest",
      "baseName": "latest",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return PitrRestoreWindow.attributeTypeMap;
  }

  public constructor() {
  }
}

